var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "netgsm-webhooks" } },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "left" }, [
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.netgsmWebhooksTitle")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("message.netgsmWebhooksSubtitle")))]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary", icon: "plus" },
                on: {
                  click: function ($event) {
                    _vm.showAddModal = true
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.netgsmWebhooksAddBtn")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { icon: "reload", loading: _vm.loading },
                on: { click: _vm.refreshWebhooks },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.refresh")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getCols(),
              rows: _vm.webhooks,
              loading: _vm.loading,
              "bottom-pagination": "",
              "pagination-cursor": _vm.pagination,
              options: {
                fixedHeader: true,
                borderX: true,
                borderY: true,
              },
            },
            on: {
              "cursor-changed": function (cursor) {
                return (_vm.pagination = cursor)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.showAddModal,
            title: _vm.$t("message.netgsmWebhooksModalAddTitle"),
            confirmLoading: _vm.saving,
            width: "600px",
          },
          on: { ok: _vm.handleSave, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-form",
            { attrs: { layout: "vertical" } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: _vm.$t("message.netgsmWebhooksUrlLabel"),
                    required: "",
                  },
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: _vm.$t(
                        "message.netgsmWebhooksUrlPlaceholder"
                      ),
                      type: "url",
                    },
                    model: {
                      value: _vm.currentWebhook.responseurl,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentWebhook, "responseurl", $$v)
                      },
                      expression: "currentWebhook.responseurl",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "help-text" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.netgsmWebhooksUrlHelp")) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: { label: _vm.$t("message.netgsmWebhooksTokenLabel") },
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: _vm.$t(
                        "message.netgsmWebhooksTokenPlaceholder"
                      ),
                    },
                    model: {
                      value: _vm.currentWebhook.urltoken,
                      callback: function ($$v) {
                        _vm.$set(_vm.currentWebhook, "urltoken", $$v)
                      },
                      expression: "currentWebhook.urltoken",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "help-text" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.netgsmWebhooksTokenHelp")) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("message.netgsmWebhooksDeleteModalTitle"),
            confirmLoading: _vm.deleting,
          },
          on: {
            ok: _vm.confirmDelete,
            cancel: function ($event) {
              _vm.showDeleteModal = false
            },
          },
          model: {
            value: _vm.showDeleteModal,
            callback: function ($$v) {
              _vm.showDeleteModal = $$v
            },
            expression: "showDeleteModal",
          },
        },
        [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.netgsmWebhooksDeleteConfirm"))),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v(_vm._s(_vm.$_.get(_vm.deletingWebhook, "responseurl"))),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }